import { render, staticRenderFns } from "./CookiesDisabledError.vue?vue&type=template&id=4c7c020c&scoped=true"
import script from "./CookiesDisabledError.vue?vue&type=script&lang=js"
export * from "./CookiesDisabledError.vue?vue&type=script&lang=js"
import style0 from "./CookiesDisabledError.vue?vue&type=style&index=0&id=4c7c020c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c020c",
  null
  
)

export default component.exports